import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "heading-title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "form-group mb-3" }
const _hoisted_4 = {
  for: "email",
  class: "form-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "form-group mt-4" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, "Enter Email " + _toDisplayString(_ctx.verificationTxt), 1),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_ctx.isFormInvalid)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode("Email "),
          _createVNode(_component_ToolTip, { tooltipText: "This is required to proceed with the verification process and to send you a confirmation regarding your elections." })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          maxlength: "250",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.emailAddress) = $event)),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideErrors('emailAddress'))),
          id: "email",
          class: _normalizeClass(["form-control", _ctx.v$.user.emailAddress.$error ? 'is-invalid' : 'input-text'])
        }, null, 34), [
          [_vModelText, _ctx.user.emailAddress]
        ]),
        (_ctx.v$.user.emailAddress.$error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.emailAddress.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: index
                }, [
                  (
                error.$validator == 'required' || error.$validator == 'email'
              )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'is-invalid': _ctx.v$.user.emailAddress.$error })
                      }, "Please enter a valid email address", 2))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.v$.user.emailAddress.$invalid || _ctx.isSubmitDisabled,
          class: _normalizeClass(["btn w-100", [_ctx.buttonDesign()]]),
          id: "button-verifyemail",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.verifyEmail && _ctx.verifyEmail(...args)))
        }, " SEND CODE ", 10, _hoisted_7)
      ])
    ], 32)
  ]))
}